<template>
  <b-form
    v-if="validRequest"
    :novalidate="true"
  >
    <FeedbackInput
      :rating.sync="rating1"
    >
      <template #label><slot name="feedback1Label"></slot></template>
      <template #labelLowBoundary><slot name="feedback1LowBoundary"></slot></template>
      <template #labelHighBoundary><slot name="feedback1HighBoundary"></slot></template>
    </FeedbackInput>
    <FeedbackInput
      :rating.sync="rating2"
    >
      <template #label><slot name="feedback2Label"></slot></template>
      <template #labelLowBoundary><slot name="feedback2LowBoundary"></slot></template>
      <template #labelHighBoundary><slot name="feedback2HighBoundary"></slot></template>
    </FeedbackInput>
    <FeedbackInput
      :rating.sync="rating3"
    >
      <template #label><slot name="feedback3Label"></slot></template>
      <template #labelLowBoundary><slot name="feedback3LowBoundary"></slot></template>
      <template #labelHighBoundary><slot name="feedback3HighBoundary"></slot></template>
    </FeedbackInput>
    <FeedbackInput
      :rating.sync="rating4"
    >
      <template #label><slot name="feedback4Label"></slot></template>
      <template #labelLowBoundary><slot name="feedback4LowBoundary"></slot></template>
      <template #labelHighBoundary><slot name="feedback4HighBoundary"></slot></template>
    </FeedbackInput>
    <b-form-group class="form-group-feedback-text">
      <label>
        <slot name="lblTextareaYourFeedback"></slot>
      </label>
      <b-form-textarea
        id="textarea"
        v-model="comment"
        rows="5"
        :placeholder="this.$slots.txtPlaceholderTextareaYourFeedback && this.$slots.txtPlaceholderTextareaYourFeedback[0] ? this.$slots.txtPlaceholderTextareaYourFeedback[0].text : 'Hier Texten'"
      ></b-form-textarea>
    </b-form-group>
    <div class="buttons">
        <button @click="submit" class="filled" type="button" :disabled="loading">
          <slot name="btnSendYourFeedback">weiter</slot>
        </button>
    </div>
  </b-form>
</template>
<script>

import transaction from '@/mixins/transaction'
import FeedbackInput from '@/components/generic/FeedbackInput.vue'
import urlParam from '@/mixins/urlParam'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import trackingHandler from '@/mixins/trackingHandler'

export default {
  name: 'FeedbackWrapper',
  data () {
    return {
      validRequest: false,
      loading: false,
      question1: null,
      rating1: null,
      question2: null,
      rating2: null,
      question3: null,
      rating3: null,
      question4: null,
      rating4: null,
      comment: null,
      commentLabel: null
    }
  },
  props: {
    invalidLinkUrl: {
      Type: String,
      default: '/'
    },
    successUrl: {
      Type: String,
      default: '/'
    }
  },
  components: { FeedbackInput },
  mixins: [
    transaction('tnpsFeedback'),
    urlParam,
    trackingHandler
  ],
  mounted () {
    // get questions from slots
    this.question1 = this.$slots.feedback1Label && this.$slots.feedback1Label[0] ? this.$slots.feedback1Label[0].text : ''
    this.question2 = this.$slots.feedback2Label && this.$slots.feedback2Label[0] ? this.$slots.feedback2Label[0].text : ''
    this.question3 = this.$slots.feedback3Label && this.$slots.feedback3Label[0] ? this.$slots.feedback3Label[0].text : ''
    this.question4 = this.$slots.feedback4Label && this.$slots.feedback4Label[0] ? this.$slots.feedback4Label[0].text : ''
    this.commentLabel = this.$slots.lblTextareaYourFeedback && this.$slots.lblTextareaYourFeedback[0] ? this.$slots.lblTextareaYourFeedback[0].text : ''

    let isInvalidUrl = false

    // get feedback token
    const solicitorId = this.getURLParam('optparam')
    if (solicitorId !== null && solicitorId !== '') {
      this.setSolicitorId(solicitorId)
    } else {
      isInvalidUrl = true
    }

    if (!isInvalidUrl) {
      this.validRequest = true
    } else {
      window.location.href = this.invalidLinkUrl
    }
  },
  methods: {
    ...mapMutations('feedbackProcess', ['setSolicitorId']),
    ...mapActions('feedbackProcess', ['sendAnswers']),
    async submit () {
      this.startLoader()
      return new Promise((resolve) => {
        this.loading = true
        this.sendAnswers({ questions: this.getQuestions, answers: this.getAnswers, successStepName: '' })
          .then(() => {
            this.$store.commit('Transaction/removeTransactionId', 'tnpsFeedback', { root: true })
            window.location.href = this.successUrl
            resolve()
          })
          .catch((error) => {
            this.loading = false
            this.errorToast(this.getErrorMessage(error))
            resolve()
          })
          .finally(() => this.stopLoader())
      })
    }
  },
  computed: {
    ...mapGetters('feedbackProcess', ['solicitorId']),
    getQuestions () {
      return [
        {
          id: 1,
          answerType: 'numberRange',
          questionText: this.question1
        },
        {
          id: 2,
          answerType: 'numberRange',
          questionText: this.question2
        },
        {
          id: 3,
          answerType: 'text',
          questionText: this.commentLabel
        },
        {
          id: 4,
          answerType: 'numberRange',
          questionText: this.question3
        },
        {
          id: 5,
          answerType: 'numberRange',
          questionText: this.question4
        }
      ]
    },
    getAnswers () {
      return {
        1: this.rating1,
        2: this.rating2,
        3: this.comment,
        4: this.rating3,
        5: this.rating4
      }
    }
  }
}
</script>
